import AppEvents from "../pxg/AppEvents";
import AppMessaging from "../pxg/AppMessaging";
import BTASession from "./BTASession";
import DataManager from "./data/DataManager";

export const appEvents = new AppEvents();
export const appMessaging = new AppMessaging();
export const appSession = new BTASession();
export const dataManager = new DataManager();
